import React from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

const styles = css`
    font-size: 24px;
    margin: 0;
    padding: 25px 0px;
`;

const Heading = styled(
    ({ level, children, reverse, palette, theme, ...props }) =>
        React.createElement(`h${level}`, props, children)
)`
    ${styles}
`;

Heading.propTypes = {
    level: PropTypes.number,
    children: PropTypes.node,
    palette: PropTypes.string,
    reverse: PropTypes.bool,
};

Heading.defaultProps = {
    level: 1,
    palette: "grayscale",
};

export default Heading;
